var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      ref: "settingsEmailsTemplatesRef",
      staticClass: "settings-emails-templates"
    },
    [
      _c(
        "div",
        { staticClass: "settings-emails-templates__header" },
        [
          _vm.mode === _vm.MODE.NONE
            ? _c("CompassButton", {
                attrs: {
                  label: _vm.translations.btnLabelAddTemplate,
                  "data-bot": "settings-emails-templates__add-template",
                  leftIcon: "plus"
                },
                on: { click: _vm.handleAddTemplate }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "settings-emails-templates__container" }, [
        _c(
          "div",
          { staticClass: "settings-emails-templates__listing" },
          [
            _c(
              "CompassTabs",
              {
                staticClass: "settings-emails-templates__tabs",
                model: {
                  value: _vm.tabSelected,
                  callback: function($$v) {
                    _vm.tabSelected = $$v
                  },
                  expression: "tabSelected"
                }
              },
              _vm._l(_vm.getTabs, function(tab, key) {
                return _c(
                  "CompassTabPane",
                  {
                    key: key,
                    attrs: {
                      name: tab.name,
                      label: tab.label,
                      badge: tab.badge,
                      badgeColor: "default"
                    }
                  },
                  [
                    tab.name === "myTemplates"
                      ? _c("CompassInput", {
                          staticClass: "settings-emails-templates__search",
                          attrs: {
                            type: "search",
                            placeholder: _vm.translations.placeholderSearch,
                            prefixIcon: "search",
                            disabled: _vm.disableSearch,
                            "data-bot": "settings-emails-templates__search"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "suffix",
                                fn: function() {
                                  return [
                                    _c("CompassIconButton", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.hasSearchQuery,
                                          expression: "hasSearchQuery"
                                        }
                                      ],
                                      attrs: {
                                        icon: "close",
                                        size: "small",
                                        disabled: _vm.disableSearch,
                                        "data-bot":
                                          "settings-emails-templates__reset"
                                      },
                                      on: { click: _vm.resetSearch }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.searchQuery,
                            callback: function($$v) {
                              _vm.searchQuery = $$v
                            },
                            expression: "searchQuery"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isLoadingTemplates
                      ? _c(
                          "div",
                          { staticClass: "settings-emails-templates__loading" },
                          _vm._l(5, function(index) {
                            return _c("CompassSkeleton", {
                              key: index,
                              staticClass:
                                "settings-emails-templates__loading--skeleton",
                              attrs: { size: "large" }
                            })
                          }),
                          1
                        )
                      : _vm.filteredTemplates
                      ? _c(
                          "div",
                          {
                            staticClass: "settings-emails-templates__templates"
                          },
                          _vm._l(_vm.filteredTemplates, function(template) {
                            return _c(
                              "li",
                              {
                                key: template.id,
                                class: _vm.classesTemplatesItem(template),
                                attrs: {
                                  "data-bot":
                                    "settings-emails-templates__template"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectTemplate(template)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(template.name) +
                                    "\n                            "
                                ),
                                template.hasAi
                                  ? _c("CompassIcon", {
                                      staticClass:
                                        "settings-emails-templates__ai-icon",
                                      attrs: {
                                        icon: "ai-sparkles-simple",
                                        size: "small"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm.emptyTemplates || _vm.noFilterResult
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "settings-emails-templates__no-template"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-regular"
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.translations.noTemplateLabel) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "settings-emails-templates__content" },
          [
            _vm.isLoadingTemplates || _vm.isLoadingTemplate
              ? [_c("CompassSkeleton", { attrs: { lines: 5 } })]
              : _vm.mode !== _vm.MODE.NONE && _vm.selectedTemplate
              ? _c("SettingsEmailsTemplatesForm", {
                  staticClass: "settings-emails-templates__content--template",
                  attrs: {
                    mode: _vm.mode,
                    tags: _vm.tags,
                    template: _vm.selectedTemplate
                  },
                  on: {
                    "save-email-template": _vm.saveTemplate,
                    "is-editor-focused": _vm.setIsEditorFocused
                  }
                })
              : _vm.emptyTemplates || _vm.noFilterResult
              ? _c(
                  "div",
                  {
                    staticClass:
                      "settings-emails-templates__content--no-template"
                  },
                  [
                    _vm.emptyTemplates
                      ? _c("CompassEmptyState", {
                          attrs: {
                            illustrationPath:
                              "/ressources/logged/img/illustrations/custom-email-template-no-result.svg",
                            title: _vm.translations.noTemplateTitle
                          }
                        })
                      : _vm.noFilterResult
                      ? _c("CompassEmptyState", {
                          attrs: {
                            illustrationPath:
                              "/ressources/logged/img/illustrations/no-results.svg",
                            title: _vm.translations.noFilterResultTitle,
                            caption: _vm.translations.noFilterResultCaption
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm.selectedTemplate
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "settings-emails-templates__content--template"
                    },
                    [
                      _c("div", {
                        staticClass:
                          "rich-text-style settings-emails-templates__content--subject typographies-heading-h3",
                        domProps: {
                          innerHTML: _vm._s(_vm.selectedTemplate.subject)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "rich-text-style settings-emails-templates__content--message",
                        class: _vm.editorClass,
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.addBrToEmptyPragraphs(
                              _vm.selectedTemplate.message
                            )
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm.selectedTemplate.attachments.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "settings-emails-templates__attachments"
                            },
                            _vm._l(_vm.selectedTemplate.attachments, function(
                              attachment
                            ) {
                              return _c("EmailAttachmentLink", {
                                key: attachment.id,
                                attrs: { file: attachment, size: "small" }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "settings-emails-templates__content--signature"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-small-semibold"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.translations.labelYour) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("CompassLink", {
                        attrs: {
                          label: _vm.$t.__("common.labels.signature"),
                          size: "small"
                        },
                        on: { click: _vm.getLinkSignature }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-small-semibold"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.translations.labelSignatureDetails) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.showActionsFooter
        ? _c("div", { staticClass: "settings-emails-templates__footer" }, [
            _c(
              "div",
              { staticClass: "settings-emails-templates__actions" },
              [
                _vm.mode === _vm.MODE.NONE
                  ? [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.labels.edit"),
                          "data-bot": "settings-emails-templates__edit"
                        },
                        on: { click: _vm.handleEdit }
                      }),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.duplicate"),
                          type: "secondary",
                          "data-bot": "settings-emails-templates__duplicate"
                        },
                        on: { click: _vm.handleDuplicate }
                      }),
                      _vm._v(" "),
                      _c("CompassIconButton", {
                        attrs: {
                          icon: "bin",
                          "data-bot": "settings-emails-templates__delete"
                        },
                        on: { click: _vm.handleDelete }
                      })
                    ]
                  : [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.save"),
                          "data-bot": "settings-emails-templates__save",
                          loading: _vm.isLoadingActions
                        },
                        on: { click: _vm.handleSave }
                      }),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.cancel"),
                          type: "secondary",
                          "data-bot": "settings-emails-templates__cancel",
                          disabled: _vm.isLoadingActions
                        },
                        on: { click: _vm.handleCancel }
                      })
                    ]
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showHint,
                  expression: "showHint"
                }
              ],
              staticClass:
                "settings-emails-templates__ai-hint typographies-paragraph-small-regular",
              domProps: { innerHTML: _vm._s(_vm.$t.__("richtext.ai.hint")) }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteModal && _vm.selectedTemplate
        ? _c("SettingsEmailsTemplatesDeleteModal", {
            attrs: {
              template: _vm.selectedTemplate,
              visible: _vm.showDeleteModal
            },
            on: {
              "update:visible": function($event) {
                _vm.showDeleteModal = $event
              },
              close: function($event) {
                _vm.showDeleteModal = false
              },
              deleted: _vm.handleTemplateDeleted
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showWarningEditionModal
        ? _c("SettingsEmailsTemplatesWarningEditionModal")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }